import React from 'react';
import { Form } from 'antd';
import WizardForm from '@severalnines/bar-frontend-components/build/lib/Navigation/WizardForm';
import WizardFormConfiguration from '@severalnines/bar-frontend-components/build/lib/Navigation/Wizard/WizardFormConfiguration';
import CcCluster from '../../../../services/models/CcCluster';
import { FormInstance } from 'antd/lib/form';
import useCreateJob from '../../../Jobs/useCreateJob';
import { CmonJobInstanceCommand } from '../../../../services/cmon/models/CmonJobInstance';
import CreateGarbdConfiguration, {
    GARBD_CONFIG_INITIAL,
    getCreateGarbdConfigurationValidation,
} from './CreateGarbdConfiguration';
import CreateGarbdPreview from './CreateGarbdPreview';

export enum GarbdFormSteps {
    CONFIGURATION = 'Configuration',
    PREVIEW = 'Preview',
}

export type CreateGarbdWizardFormProps = {
    onCancel?: () => void;
    onSuccess?: () => void;
    onError?: (err: Error) => void;
    onStepErrorInsist?: (err: Error) => void;
    onTouchedChange?: (touched: boolean) => void;
    cluster?: CcCluster;
};

export default CreateGarbdWizardForm;

function CreateGarbdWizardForm({
    onCancel,
    onSuccess,
    onStepErrorInsist,
    onTouchedChange,
    onError,
    cluster,
}: CreateGarbdWizardFormProps) {
    const [form] = Form.useForm();

    const { loading, send } = useCreateJob({
        clusterId: cluster?.clusterId,
        title: 'Setup Garbd',
        command:
            CmonJobInstanceCommand.GARBD.toLowerCase() as CmonJobInstanceCommand,
        onSuccess,
    });

    const handleSubmit = async () => {
        try {
            const { garbdConfig } = form.getFieldsValue(true);
            const [address] = garbdConfig.address;
            await send(
                {
                    clusterId: cluster?.clusterId,
                    ...formatFields(form),
                },
                {
                    job: {
                        title: `Setup Garbd Server ${address?.extraData.hostname}`,
                    },
                }
            );
        } catch (err: any) {
            if (onError) {
                onError(err);
            }
        }
    };
    return (
        <WizardFormConfiguration
            form={form}
            onSubmit={handleSubmit}
            loading={loading}
            onCancel={onCancel}
            initialValues={{
                ...GARBD_CONFIG_INITIAL,
            }}
            onStepErrorInsist={onStepErrorInsist}
            onTouchedChange={onTouchedChange}
            steps={[
                <WizardForm.Step
                    key={GarbdFormSteps.CONFIGURATION}
                    title="Configuration"
                    subTitle=" "
                    validate={getCreateGarbdConfigurationValidation(form)}
                >
                    <CreateGarbdConfiguration
                        selectedCluster={cluster}
                        form={form}
                    />
                </WizardForm.Step>,
                <WizardForm.Step
                    key={GarbdFormSteps.PREVIEW}
                    title="Preview"
                    subTitle=" "
                >
                    <CreateGarbdPreview form={form} />
                </WizardForm.Step>,
            ]}
        />
    );
}

export function formatFields(form: FormInstance) {
    const { garbdConfig } = form.getFieldsValue(true);

    const [address] = garbdConfig.address;
    const date = {
        action: 'setupGarbd',
        hostname: address?.extraData.hostname,
        cmdline: garbdConfig.cmdline,
        disable_firewall: garbdConfig.firewall,
        disable_selinux: garbdConfig.appArmor,
    };
    return date;
}
